var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex",
        staticStyle: { position: "absolute", bottom: "0.5vh" }
      },
      [
        _c("img", {
          staticClass: "footer-logo",
          attrs: { src: "/bccrc-logo-text.png", alt: "BC Cancer" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "footer-logo",
          attrs: { src: "/qurit-logo-text.png", alt: "Qurit" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }